module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.28.0-f3d742a11.svg#youtube-play","viewBox":"0 0 87 115"}